export default (product, filter) => (filter && filter.length ? !!~filter.indexOf(product.get('product')?.get('operator')?.id) : true);